<!--事件处理-上下线管理-->
<template>
  <div>
    <!-- 工具条 -->
    <el-col :span="24" class="toolbar" style="padding-bottom: 0">
      <el-form :inline="true" :model="filter" size="mini">
        <el-form-item>
          <el-select
            style="width: 200px;"
            placeholder="处理状态"
            @change="handleFilterChange"
            v-model="filter.status"
            clearable
            filterable
          >
            <el-option :value="0" label="待审核"/>
            <el-option :value="1" label="已通过"/>
            <el-option :value="2" label="未通过"/>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-select
            style="width: 200px;"
            placeholder="申请类型"
            @change="handleFilterChange"
            v-model="filter.type"
            clearable
            filterable
          >
            <el-option :value="1" label="上线申请"/>
            <el-option :value="2" label="停业申请"/>
            <el-option :value="3" label="歇业申请"/>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-cascader
            placeholder="所属单位"
            @change="handleFilterChange"
            v-model="filter.owner"
            :options="customerTree"
            :props="customerProps"
            clearable
            filterable
          />
        </el-form-item>
        <el-form-item>
          <el-date-picker
            v-model="filter.start_time"
            type="daterange"
            range-separator="至"
            start-placeholder="提交开始日期"
            end-placeholder="结束日期"
            @change="handleFilterChange"
            value-format="timestamp">
          </el-date-picker>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="openExportSizeInput">导出</el-button>
        </el-form-item>
      </el-form>
    </el-col>

    <el-table
      ref="multipleTable"
      :data="tableData"
      :loading="loading"
      size="mini"
        border
        highlight-current-row
        v-loading="loading"
        @selection-change="selsChange"
        :max-height="clientHeight"
        style="width: 100%"
      >

      <el-table-column  type="selection"  :selectable="checkSelectable" />

      <el-table-column type="index" label="#" align="center" width="55"/>
      <el-table-column
        prop="locale_name"
        show-overflow-tooltip
        label="监测点"
        align="center">
      </el-table-column>
      <el-table-column
        prop="owner_name"
        align="center"
        show-overflow-tooltip
        label="所属单位">
      </el-table-column>
      <el-table-column
        prop="mn"
        align="center"
        show-overflow-tooltip
        label="设备编号">
      </el-table-column>
      <el-table-column
        prop="create_at"
        align="center"
        show-overflow-tooltip
        label="提交时间"
        width="180"
        sortable>
      </el-table-column>
      <el-table-column
        prop="user_name"
        align="center"
        label="提交人">
      </el-table-column>
      <el-table-column
        prop="reason"
        align="center"
        show-overflow-tooltip
        label="上下线原因">
      </el-table-column>
      <el-table-column
        prop="status_info"
        align="center"
        label="处理状态"
        sortable>
        <template slot-scope="scope">
          <el-tag type="success" v-if="scope.row.status_info==='已通过'">已通过</el-tag>
          <el-tag type="danger" v-else-if="scope.row.status_info==='未通过'">未通过</el-tag>
          <el-tag v-else>{{ scope.row.status_info }}</el-tag>
        </template>
      </el-table-column>
      <el-table-column
        prop="handle_at"
        align="center"
        show-overflow-tooltip
        label="处理日期"
        sortable>
      </el-table-column>
      <el-table-column
        align="center"
        label="操作">
        <template slot-scope="scope">
          <i
            title="编辑"
            v-if="scope.row.status_info==='待审核'"
            @click="handleEdit(scope.row)"
            class="opt el-icon-edit"
            style="color: #469afb"
          />
          <i
            title="查看"
            @click="handleView(scope.row)"
            class="opt el-icon-view"
            style="color: #469afb"
          />
          <i
            title="删除"
            @click="handleDel(scope.row)"
            class="opt el-icon-delete"
          />
        </template>
      </el-table-column>
    </el-table>

    <div class="toolbar">
      <el-button
        type="primary"
        size="mini"
        @click="bulkExam"
        :disabled="sels.length === 0 || (role !== 'sa' &&  role !== 'Charger')"
      >批量审核
      </el-button>
      <el-pagination
        small
        background
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page.sync="filter.page"
        :page-sizes="filter.pageSizes"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
        style="display: inline-block; margin-left: 15px"
      >
      </el-pagination>
    </div>

    <offline-view-dialog
      :id="id"
      :visible.sync="viewVisible"
      :mode="viewMode"
      @handleClose="handleViewClose"
      :topStyle="20"
    />
    <el-dialog
      title="批量审核"
      :visible.sync="verifyVisible"
      width="30%"
      center>
      <el-form>
        <el-form-item label="审核备注：">
          <el-input
            placeholder="请输入审核备注"
            v-model="editRemark"/>
        </el-form-item>
      </el-form>
      <span slot="footer">
        <el-button type="primary" @click="handleVerifyStatus(1)">通  过</el-button>
        <el-button type="danger" @click="handleVerifyStatus(2)">不通过</el-button>
      </span>
    </el-dialog>

  </div>
</template>
<script>
import {mapState} from "vuex";
import {getUserInfo, ownerJoin} from "@/util";
import dayjs from "dayjs";
import OfflineViewDialog from "@/component/offlineManagement/OfflineViewDialog.vue";

export default {
  name: 'OfflineManagement',
  components: {OfflineViewDialog},
  data() {
    return {
      filter: {
        page: 1,
        size: 20,
        status: null,
        type: null,
        owner: [],
        date: null,
        is_download: false,
        start_time: null,
        end_time: null,
        pageSizes: [20, 30, 50]
      },
      verifyVisible: false,
      verifyId: '',
      editRemark: '',
      sels: [], // 列表选中列
      role: null,
      customerProps: {
        value: 'Id',
        label: 'Name',
        children: 'children',
        checkStrictly: true
      },
      tableData: [],
      loading: false,
      total: 0,
      viewVisible: false,
      id: null,
      viewMode: null
    }
  },
  computed: {
    ...mapState(['customerTree','clientHeight']),
  },
  mounted() {
    this.userInfo = getUserInfo().Info
    this.role = sessionStorage.getItem('role')
    this.getData()
  },
  methods: {
    checkSelectable(row, index) {
      if (row.status == 0 && this.role == "sa" && row.handle_at != "") {
        return true
      }
      if (row.status == 0 && this.role == "Charger" && row.handle_at == "") {
        return true
      }
      return false;
    },
    selsChange: function (sels) {
      this.sels = []
      for(var i = 0; i < sels.length; i++) {
        if (sels[i].status == 0) {
          if (this.role == "sa" && sels[i].handle_at != "") {
            this.sels.push(sels[i])
          }
          if (this.role == "Charger" && sels[i].handle_at == "") {
            this.sels.push(sels[i])
          }
        } else {
          break
        }
      }
    },

    handleVerifyStatus(status) {
      if (this.editRemark == "") {
        this.$message("备注不能为空")
        return
      }
      let formData = new URLSearchParams()
      formData.append('id', this.verifyId)
      formData.append("remark", this.editRemark)
      formData.append("status", status)
      this.$post('admin/exam_log/add', formData).then(res => {
        this.$message({
          type: 'success',
          message: "审核成功"
        })
        this.verifyVisible = false
        this.getData()
        this.$emit("handleClose")
      })
    },
    bulkExam: function () {
      if (this.sels.length !== 0) {
        const ids = this.sels.map((item) => item.Id).toString()
        this.$confirm('确认审核所有选中记录吗？', '提示', {
          type: 'warning'
        })
          .then(() => {
            if (this.sels.length !== 0) {
              const ids = this.sels.map((item) => item.id).toString()
              this.editRemark = ''
              this.verifyVisible = true
              this.verifyId = ids
            }
          })
          .catch(() => {
          })
      }
    },
    handleCurrentChange(page) {
      this.filter.page = page
      this.getData()
    },
    handleSizeChange(size) {
      this.filter.size = size
      this.getData()
    },
    // 新增方法：处理筛选条件变化
    handleFilterChange() {
      // 筛选条件变化时，重置页码到第一页
      this.filter.page = 1;
      this.getData();
    },
    getData() {
      this.loading = true
      let param = Object.assign({}, this.filter)
      if (param.owner.length !== 0) {
        let userInfo = getUserInfo().Info
        param.owner = ownerJoin(param.owner, userInfo)
      }
      if (this.filter.start_time) {
        param.end_time = this.filter.start_time[1] / 1000 + 60 * 60 * 24 - 1
        param.start_time = this.filter.start_time[0] / 1000
      }
      this.$get('admin/offline_apply', param).then(res => {
        this.tableData = res.list
        this.total = res.count
        this.loading = false
      })
    },
    openExportSizeInput() {
      this.$prompt(`请输入导出的数据量（总量：${this.total} 条）`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        inputPattern: /^[0-9]*$/,
        inputErrorMessage: '只能填入数字'
      }).then(({value}) => {
        this.handleExport(parseInt(value))
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '取消'
        })
      })
    },
    handleExport(num) {
      //定义加载中的动画
      const loading = this.$loading({
        lock: true,
        text: 'Loading',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)',
        target: document.querySelector(".submit-dialog") // .submit-dialog 指的是 el-dialog 的 class
      });
      let param = Object.assign({}, this.filter)
      param.size = num
      param.is_download = 1
      if (param.owner.length !== 0) {
        let userInfo = getUserInfo().Info
        param.owner = ownerJoin(param.owner, userInfo)
      }
      if (this.filter.start_time) {
        param.end_time = this.filter.start_time[1] / 1000 + 60 * 60 * 24 - 1
        param.start_time = this.filter.start_time[0] / 1000
      }

      this.$get('admin/offline_apply', param).then(res => {
        let url = res.url
        const link = document.createElement('a')
        link.setAttribute('href', url)
        link.click()
        loading.close()
      })
    },
    handleEdit(row) {
      this.id = row.id
      this.viewVisible = true
      this.viewMode = 'edit'
    },
    // 查看
    handleView(row) {
      this.id = row.id
      this.viewVisible = true
      this.viewMode = 'view'
    },
    handleViewClose() {
      this.viewVisible = false
      this.getData()
    },
    handleDel(row) {
      this.$confirm('确认删除该记录吗?', '提示', {
        type: 'warning'
      }).then(() => {
          this.$post('admin/offline_apply/delete/' + row.id).then(res => {
            this.$message({
              type: 'success',
              message: '删除成功'
            })
            this.getData()
          })
        })
    }
  }
}
</script>
<style scoped lang="scss">

</style>
